import { call, put, takeEvery, all } from 'redux-saga/effects'
import myDriverTypes from './myDriverTypes'
import * as myDriverActions from './myDriversActions'
import MyDrivers from '../../services/TractorService/MyDrivers'
import notificationActions from '../notifications/notificationActions'

export function * getMyDrivers ({ payload }) {
  try {
    const { offset } = payload
    if (offset === 0) {
      yield put(myDriverActions.clearMyDrivers())
    }
    const { data, results = 1 } = yield call(MyDrivers.getMyDrivers, payload)
    yield put(myDriverActions.getMyDriversSuccess({ data, results }))
  } catch ({ message }) {
    yield put(myDriverActions.getMyDriversFailure(message))
  }
}

export function * setDriver ({ payload, callback }) {
  try {
    const { data } = yield call(MyDrivers.setDriver, payload)
    const response = data?.driver_id ? { ...payload, driver_id: data?.driver_id } : payload
    yield put(myDriverActions.setMyDriverSuccess(response))
    if (callback) yield callback()
    yield put(notificationActions.SendToast({ message: 'Driver edited succesfully', type: 'success' }))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(myDriverActions.setMyDriverFailure(message))
  }
}

export function * deleteMyDriver ({ payload, callback }) {
  try {
    yield call(MyDrivers.destroy, payload)
    yield put(myDriverActions.deleteMyDriverSuccess(payload))
    yield put(notificationActions.SendToast({ message: 'Driver deleted succesfully', type: 'success' }))
    if (callback) yield callback()
  } catch ({ message }) {
    yield put(myDriverActions.deleteMyDriverFailure(message))
    yield put(notificationActions.SendToast({ message, type: 'error' }))
  }
}

export function * onGetMyDrivers () {
  yield takeEvery(myDriverTypes.GET_DRVIERS, getMyDrivers)
}

export function * onSetMyDrivers () {
  yield takeEvery(myDriverTypes.SET_DRVIERS, setDriver)
}

export function * onDeleteMyDrivers () {
  yield takeEvery(myDriverTypes.DELETE_DRVIERS, deleteMyDriver)
}

export function * myDriverSaga () {
  yield all([
    call(onGetMyDrivers),
    call(onSetMyDrivers),
    call(onDeleteMyDrivers)
  ])
}
